<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.vehicles') }}
        </div>
        <div class="va-card__header-actions">
          <va-button small icon="fa fa-plus" to="/arac/ekleme">{{ $t('tables.actions.create') }}</va-button>
        </div>
      </template>
      <div class="row align--center mt-1">
        <div class="flex xs12 md6">
          <va-input
            v-model="filter.name"
            :label="$t('tables.searchBy.name')"
          />
        </div>
        <div class="flex xs3 sm2 md1">
          <div class="btn--wrapper">
            <va-button small outline @click.stop="onfilter" icon="fa fa-search"/>
            <va-button v-show="hasFilter" small outline @click.stop="onclearfilter" icon="fa fa-eraser"/>
          </div>
        </div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
        @row-clicked="show"
      >
        <template slot="name_readable" slot-scope="props">
          <va-item class="px-0">
            <va-item-section avatar>
              <va-avatar v-if="props.rowData.images_readable.length > 0">
                <img :src="props.rowData.images_readable[0]"/>
              </va-avatar>
              <va-avatar v-else>
                <va-icon name="fa fa-car" class="mx-auto my-auto"/>
              </va-avatar>
            </va-item-section>
            <va-item-section>
              <va-item-label>
                {{props.rowData.name_readable}}
              </va-item-label>
            </va-item-section>
          </va-item>
        </template>

        <template slot="vehicle_segment_id" slot-scope="props">
          {{ !!props.rowData.segment ? props.rowData.segment.name_readable : ''}}
        </template>

        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tables.actions.edit')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-pencil" @click.stop="buttonAsHref('/arac/'+props.rowData.id+'/duzenleme')"/>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.destroy')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="warning" icon="fa fa-trash"  @click.stop="confirmDeleteVehicle(props.rowData)"/>
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-pagination
      v-model="pages.current_page"
      :visible-pages="3"
      :pages="pages.last_page"
      class="mt-3"
      :small="true"
      color="secondary"
    />
  </div>
</template>

<script>
import vehicleServices from '../../services/api/vehicle'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      filter: {
        name: null
      },
      hasFilter: false,
      pages: {
        current_page: 1,
        last_page: 1
      },
      showConfirmationModal: false
    }
  },
  computed: {
    fields () {
      return [{
        name: '__slot:name_readable',
        title: this.$t('tables.headings.vehicle.name'),
        width: '30%',
      }, {
        name: '__slot:vehicle_segment_id',
        title: this.$t('tables.headings.vehicle.segment'),
        width: '20%',
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },
  watch: {
    'pages.current_page': function(val) {
      let q = {};
      q.sayfa = val;
      if(this.filter.name !== null) {
        q.arac = this.filter.name;
      }
      this.$router.push({ path: '/arac/listesi', query: q });
      this.getVehicles(val, JSON.parse(JSON.stringify(this.filter)));
    },
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    async getVehicles(page=1, filter = {}){
      this.loading = true;
      this.hasFilter = !!this.filter.name;

      filter.include = 'segment';
      filter.page = page;
      filter.limit = 15;
      filter.sort = '-id';

      const result = await vehicleServices.get('', {
          params: filter
        });
      this.loading = false;
      if(result.error){
        this.items = [];
        return ;
      }
      this.items = result.data.data;
      this.pages = result.data.meta;
    },
    async deleteVehicle(id) {
      const res = await vehicleServices.delete(id);
      if(res.error){
        this.responseToast('DELETE', 'error', res);
        return ;
      }
      this.responseToast('DELETE', 'success');
      this.getVehicles(this.pages.current_page, JSON.parse(JSON.stringify(this.filter)));
    },
    confirmDeleteVehicle(item) {
      this.$dialog
        .confirm( item.name_readable + ' isimli aracı silmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Sil",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.deleteVehicle(item.id);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
    onfilter () {
      let q = this.mergeQuery();
      q.sayfa = 1;
      this.$router.push({ path: '/arac/listesi', query: q });
      this.getVehicles(1, JSON.parse(JSON.stringify(this.filter)));
    },
    onclearfilter () {
      this.$router.push({ path: '/arac/listesi' });
      this.filter = { name: null };
      this.getVehicles(1, {});
    },
    mergeQuery() {
      let q = {};
      if(!!this.filter.name) {
        q.arac = this.filter.name!="" ? this.filter.name : null;
      } else {
        this.filter.name = this.filter.name!="" ? this.filter.name : null;
      }
      return q;
    },
    splitQuery(q) {
      let page = 1;
      if(q.sayfa) {
        page = parseInt(q.sayfa);
        delete q.sayfa;
      }
      if(q !== {}) {
        if(!!q.arac) {
          this.filter.name = q.arac;
        }
      }
      this.getVehicles(page, JSON.parse(JSON.stringify(this.filter)));
    },
    show(item) {
      this.redirectTo('/arac/'+item.id);
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>

<style lang="scss" scoped>
.va-avatar {
  border-radius: 0;
  height: auto;
  max-height: 30px;
}
.btn--wrapper {
  position: relative;
  margin-top: -1rem;
}
</style>